export const ControlTypeConsts = {
  checkbox: 'DynamicControlsCheckbox',
  combobox: 'DynamicControlsComboBox',
  copywell: 'DynamicControlsCopyWell',
  customDropdown: 'DynamicControlsCustomDropDown',
  doublelistbox: 'DynamicControlsDoubleListBox',
  file: 'DynamicControlsFileInput',
  number: 'DynamicControlsInput',
  textarea: 'DynamicControlsTextarea',
  radio: 'DynamicControlsRadioGroup',
  select: 'DynamicControlsDropDown',
  singlelistbox: 'DynamicControlsSingleListBox',
  segmentedbutton: 'DynamicControlsSegmentedButton',
  spinner: 'DynamicControlsSpinnerInput',
  text: 'DynamicControlsInput',
  table: 'DynamicControlsTable',
};

export const ControlDefaultValuesConsts = {
  [ControlTypeConsts.checkbox]: false,
  [ControlTypeConsts.combobox]: '',
  [ControlTypeConsts.copywell]: '',
  [ControlTypeConsts.customDropdown]: '',
  [ControlTypeConsts.doublelistbox]: [],
  [ControlTypeConsts.file]: '',
  [ControlTypeConsts.number]: '',
  [ControlTypeConsts.textarea]: '',
  [ControlTypeConsts.radio]: '',
  [ControlTypeConsts.select]: '',
  [ControlTypeConsts.singlelistbox]: [],
  [ControlTypeConsts.spinner]: 0,
  [ControlTypeConsts.text]: '',
  [ControlTypeConsts.table]: [],
};

export const TableControlTypeConst = {
  checkbox: 'DynamicControlsCheckbox',
  combobox: 'DynamicControlsComboBox',
  copywell: 'DynamicControlsCopyWell',
  file: 'DynamicControlsFileInput',
  number: 'DynamicControlsInput',
  textarea: 'DynamicControlsTextarea',
  radio: 'DynamicControlsRadioGroup',
  select: 'DynamicControlsDropDown',
  segmentedbutton: 'DynamicControlsSegmentedButton',
  spinner: 'DynamicControlsSpinnerInput',
  text: 'DynamicControlsInput',
};
